/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ScheduledFrequencyEnum,
    ScheduledFrequencyEnumFromJSON,
    ScheduledFrequencyEnumFromJSONTyped,
    ScheduledFrequencyEnumToJSON,
} from './ScheduledFrequencyEnum';

/**
 * 
 * @export
 * @interface UpdatePersonalAssetScheduledDto
 */
export interface UpdatePersonalAssetScheduledDto {
    /**
     * 
     * @type {ScheduledFrequencyEnum}
     * @memberof UpdatePersonalAssetScheduledDto
     */
    frequency: ScheduledFrequencyEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalAssetScheduledDto
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePersonalAssetScheduledDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePersonalAssetScheduledDto
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonalAssetScheduledDto
     */
    value: number;
}

export function UpdatePersonalAssetScheduledDtoFromJSON(json: any): UpdatePersonalAssetScheduledDto {
    return UpdatePersonalAssetScheduledDtoFromJSONTyped(json, false);
}

export function UpdatePersonalAssetScheduledDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePersonalAssetScheduledDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'frequency': ScheduledFrequencyEnumFromJSON(json['frequency']),
        'name': json['name'],
        'startDate': (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'value': json['value'],
    };
}

export function UpdatePersonalAssetScheduledDtoToJSON(value?: UpdatePersonalAssetScheduledDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'frequency': ScheduledFrequencyEnumToJSON(value.frequency),
        'name': value.name,
        'startDate': (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'value': value.value,
    };
}

